<div class="loading-content">
  <div class="premium-spinner">
    <div class="inner-ring"></div>
    <div class="outer-ring"></div>
  </div>

</div>
